import { Box } from '@mui/material';
import { getCellStyle } from '../../../Utils/DecideColor';
import { RatePlanOrAttributesColumn } from '../../../Utils/RatePlanColumn';
import { Input } from 'reactstrap';
import { formatDateForDisplay } from '../../../Utils/UtilityFunctions';

export const useColumns = (
  allStartDate,
  allEndDate,
  allModifyDate,
  isBundle,
  isProvisioning,
  isUsageAttribute, selectAllService, setSelectAllService, serviceData, setSelectedService, selectedService, checkboxRef, isMobile, modalOpen
) => {
  return [
    {
      accessorKey: 'checkbox',
      header: 'checkbox',
      muiTableHeadCellProps: { sx: { order: -2, paddingRight: '0px', maxWidth: "10px" } },
      muiTableBodyCellProps: { sx: { order: -2, paddingRight: '0px', maxWidth: "10px" } },
      Header: ({ row }) => (
        <Input type="checkbox" ref={checkboxRef} className='rv-table-checkbox' checked={selectAllService} style={{ borderWidth: '2px', borderColor: '#000', borderRadius: '0' }} onClick={() => {
          setSelectAllService(!selectAllService)
          if (!selectAllService) {
            setSelectedService(serviceData)
          }
          else {
            setSelectedService([])
          }
        }} />
      ),
      enableColumnFilter: false,
      enableColumnActions: false,
      enableColumnDragging: false,
      Cell: ({ row }) => (
        <Input type="checkbox" className='rv-table-checkbox' checked={selectedService.some(p => p.serviceCode === row.original.serviceCode)} style={{ borderWidth: '2px', borderColor: '#000', borderRadius: '0' }} onClick={() => {
          handleCheckboxChange(row, selectedService, setSelectedService)
        }
        } />
      ),
      size: isMobile ? 50 : modalOpen ? 50 : 50
    },
    {
      accessorKey: "Name",
      accessorFn: (row) => `${row.name}`,
      header: 'Name',
      size: 150,
    },
    {
      accessorKey: "Service Code",
      accessorFn: (row) => `${row.serviceCode}`,
      header: 'Service Code',
      size: 170,
    },
    {
      accessorKey: "Attributes",
      accessorFn: (service, i) => `${isProvisioning[i]} ${isUsageAttribute[i]}`,
      header: 'Attributes',
      size: 200,
      Cell: ({ cell }) => {
        const attributes = cell.getValue();
        if(!attributes || attributes.trim() === '') {
          return <span>-</span>;
        }
        const [provisional, usage] = attributes?.split(' ');
        return (
          <RatePlanOrAttributesColumn provisioning={provisional} serviceUsage={usage} />
        );
      },
    },
    {
      accessorKey: "Bundled",
      accessorFn: (service, i) => `${isBundle[i]}`,
      header: 'Bundled',
      size: 150,
    },
    {
      accessorKey: "Validity",
      accessorFn: (service, i) => `${formatDateForDisplay(allStartDate[i])}-${formatDateForDisplay(allEndDate[i])}`.trim(),
      header: 'Validity',
      size: 150,
    },
    {
      accessorKey: "Last Modified",
      accessorFn: (service, i) => `${formatDateForDisplay(allModifyDate[i])}`,
      header: 'Last Modified',
      size: 170,
    },
  ];
};


export const handleCheckboxChange = (row, selectedService, setSelectedService) => {
  let isChecked = selectedService.some(p => p.serviceCode === row.original.serviceCode);
  let updatedSelectedService = isChecked
    ? selectedService.filter(p => p.serviceCode !== row.original.serviceCode)
    : [...selectedService, row.original];
  setSelectedService(updatedSelectedService);
};
